export const defaultDropdownStyle = (color) => {
    const retColor = color !== undefined && color !== null && color !== "" ? color : "#8556EB";
    return {
        control: (baseStyles) => ({
            ...baseStyles,
            border: 0,
            backgroundColor: "transparent",
            boxShadow: "none",
            cursor: "pointer"
        }),
        dropdownIndicator: (baseStyles) => ({
            ...baseStyles,
            color: retColor,
            padding: "8px 8px 8px 0px",
            "&:hover": {
                color: retColor
            }
        }),
        indicatorSeparator: (baseStyles) => ({
            ...baseStyles,
            display: "none"
        }),
        singleValue: (baseStyles) => ({
            ...baseStyles,
            color: retColor,
            padding: "2px 4px 0px",
            borderBottom: "2px solid transparent",
            "&:hover": {
                borderColor: retColor
            }
        }),
        placeholder: (baseStyles) => ({
            ...baseStyles,
            color: retColor,
            padding: "2px 4px 0px",
            whiteSpace: "nowrap",
            borderBottom: "2px solid transparent",
            "&:hover": {
                borderColor: retColor
            }
        }),
        menu: (baseStyles) => ({
            ...baseStyles,
            border: "1px solid " + retColor,
            minWidth: "224px",
            maxHeight: "220px",
            overflow: "auto",
            zIndex: 200
        }),
        menuList: () => ({
            cursor: "pointer",
            padding: "0"
        }),
        option: (styles, { isFocused }) => ({
            ...styles,
            cursor: "pointer",
            background: isFocused ? "#DDD5FF" : "none",
            color: isFocused ? retColor : "#7E7D9A"
        }),
        clearIndicator: (baseStyles) => ({
            ...baseStyles,
            padding: "0px"
        }),
        valueContainer: (baseStyles) => ({
            ...baseStyles,
            padding: "0px"
        })
    };
};
export const newChatDropdownStyle = (color) => {
    const retColor = color !== undefined && color !== null && color !== "" ? color : "#9F85F2";
    return {
        ...defaultDropdownStyle(),
        singleValue: (baseStyles) => ({
            ...baseStyles,
            color: retColor,
            padding: "4px 8px 0px",
            borderBottom: "4px solid transparent",
            fontSize: "30px",
            "&:hover": {
                borderColor: retColor
            }
        }),
        placeholder: (baseStyles) => ({
            ...baseStyles,
            color: retColor,
            padding: "4px 8px 0px",
            whiteSpace: "nowrap",
            borderBottom: "4px solid transparent",
            fontSize: "30px",
            "&:hover": {
                borderColor: retColor
            }
        }),
        menu: (baseStyles) => ({
            ...baseStyles,
            border: "1px solid " + retColor,
            fontSize: "16px",
            minWidth: "294px",
            maxHeight: "220px",
            overflow: "auto",
            zIndex: 200
        }),
        dropdownIndicator: (baseStyles) => ({
            ...baseStyles,
            color: retColor,
            padding: "8px 8px 8px 0px",
            "&:hover": {
                color: retColor
            }
        }),
        option: (styles, { isFocused }) => ({
            ...styles,
            cursor: "pointer",
            background: isFocused ? "#DDD5FF" : "none",
            color: isFocused ? retColor : "#7E7D9A"
        })
    };
};
